'use strict';

var o = require('react');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var o__default = /*#__PURE__*/_interopDefault(o);

var n=t=>e=>{if(e.preventDefault(),e.stopPropagation(),t)return t(e)};var p=typeof window!="undefined"&&typeof window.document!="undefined"&&typeof window.document.createElement!="undefined"?o__default.default.useLayoutEffect:o__default.default.useEffect;

exports.ps = n;
exports.useIsomorphicLayoutEffect = p;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.js.map